import { httpRequest } from "../../http";
import { brandAdTokenValuesUrl } from "./cmdGetBrandAdTokenValues";

/** Archives the value, which frees its ad token for a new one. */
export class CommandArchiveBrandAdTokenValue {
    async run(organizationId: string, brandId: string, valueUuid: string) {
        const url = `${brandAdTokenValuesUrl(organizationId, brandId)}${encodeURIComponent(valueUuid)}/`;
        return await httpRequest<string>(url, { method: "DELETE" });
    }
}
